import { Common, color } from '@stockbit/ui';

import SPECIAL_MONITORING from 'constants/contents/special-monitoring';

import { useMemo } from 'react';
import Image from 'global/Image';
import { StaticPageContainer } from '../../styled';
import {
  Divider,
  SpecialMonitoringBody,
  SpecialMonitoringCard,
  SpecialMonitoringContainer,
  SpecialMonitoringHeader,
} from './styled';
import SessionItem from './components/SessionItem';

interface SpecialMonitoringProps {
  mode?: 'light' | 'dark';
}

const { Text, Flex } = Common;

const SpecialMonitoringInformation = ({
  mode = 'light',
}: SpecialMonitoringProps) => {
  const CONTENT = SPECIAL_MONITORING;

  const textColor = useMemo(
    () => (mode === 'dark' ? color.lowgray : color.highempahis),
    [mode],
  );

  return (
    <StaticPageContainer mode={mode}>
      <SpecialMonitoringContainer>
        <SpecialMonitoringCard mode={mode}>
          <SpecialMonitoringHeader mode={mode}>
            <Text family="bold" color={textColor}>
              Kapan transaksi saya akan diproses?
            </Text>
          </SpecialMonitoringHeader>

          <SpecialMonitoringBody mode={mode}>
            <Text color={textColor}>
              <strong>Order saat Full Call Auction</strong>
            </Text>

            <Flex justify="space-between" width="100%" mt="12px">
              <Text size="12px" color={textColor} width="70px" />
              <Text size="12px" color="#858585" width="70px" align="center">
                Order Collection
              </Text>
              <Text size="12px" color="#858585" width="70px" align="center">
                Random Closing
              </Text>
              <Text size="12px" color="#858585" width="70px" align="center">
                Order Matching
              </Text>
            </Flex>
            {CONTENT.FULL_CALL_AUCTION.map((content, idx) => (
              <Flex
                justify="space-between"
                width="100%"
                mt="12px"
                key={`${content.label}-${idx + 1}-fca`}
              >
                <Text size="12px" color={textColor} width="70px" family="bold">
                  {content.label}
                </Text>
                {content.inclusion.map((inclusion) => (
                  <Flex align="center" justify="center" width="70px">
                    <Image
                      src={
                        inclusion
                          ? '/icon/ic-check-green.svg'
                          : '/icon/ic-close-red.svg'
                      }
                    />
                  </Flex>
                ))}
              </Flex>
            ))}

            <Divider mode={mode} dashed />

            <Text color={textColor}>
              Transaksi kamu akan diproses pada masa{' '}
              <strong>Order Matching</strong>.
            </Text>

            <Flex direction="column" my="20px">
              <Text family="bold" color={textColor}>
                Senin-Kamis
              </Text>

              {CONTENT.SESSION_A.map((session, idx) => (
                <SessionItem
                  session={session}
                  idx={idx}
                  color={textColor}
                  key={`${session.session}-${idx + 1}-session-a`}
                />
              ))}
            </Flex>

            <Divider mode={mode} dashed />

            <Flex direction="column" my="20px">
              <Text family="bold" color={textColor}>
                Jumat
              </Text>

              {CONTENT.SESSION_B.map((session, idx) => (
                <SessionItem
                  session={session}
                  idx={idx}
                  color={textColor}
                  key={`${session.session}-${idx + 1}-session-b`}
                />
              ))}
            </Flex>
          </SpecialMonitoringBody>
        </SpecialMonitoringCard>

        <SpecialMonitoringCard mode={mode}>
          <SpecialMonitoringHeader mode={mode}>
            <Text family="bold" color={textColor}>
              Kenapa saya tidak bisa langsung beli saham ini?
            </Text>
          </SpecialMonitoringHeader>

          <SpecialMonitoringBody mode={mode}>
            <Text color={textColor}>
              Per tanggal <strong>{CONTENT.SPECIAL_INFO.date}</strong>, Bursa
              Efek Indonesia menerapkan mekanisme{' '}
              <strong>{CONTENT.SPECIAL_INFO.auction}</strong> untuk saham di
              papan pemantauan khusus.
            </Text>
          </SpecialMonitoringBody>
        </SpecialMonitoringCard>

        <SpecialMonitoringCard mode={mode}>
          <SpecialMonitoringHeader mode={mode}>
            <Text family="bold" color={textColor}>
              Apa kriteria saham dalam pemantauan khusus?
            </Text>
          </SpecialMonitoringHeader>

          <SpecialMonitoringBody mode={mode}>
            <ul>
              {SPECIAL_MONITORING.CRITERIA.map((criteria, idx) => (
                <li key={`${criteria.id}-${idx + 1}-criteria`}>
                  <Text color={textColor}>{criteria.content}</Text>
                </li>
              ))}
            </ul>
          </SpecialMonitoringBody>
        </SpecialMonitoringCard>
      </SpecialMonitoringContainer>
    </StaticPageContainer>
  );
};

export default SpecialMonitoringInformation;
